import Header from "../../../components/shared/Header";
import termImage from "../../../images/termsAndConditionsImg.png"
import { useState } from "react";
import Footer from "../../../components/shared/Footer";
export default function TermsAndConditions() {
  const [open, setOpen] = useState(false);

const sections = [
  { id: "introduction", label: "Introduction", number: "01" },
  { id: "acceptance", label: "Acceptance of Terms", number: "02" },
  { id: "legal", label: "Legal Capacity", number: "03" },
  { id: "user", label: "User of the Platform", number: "04" },
  { id: "security", label: "Security Measures", number: "05" },
  { id: "prohibited", label: "Prohibited Activities", number: "06" },
  { id: "carbon", label: "      Carbon Emission Tracking and Incentives", number: "07" },
  { id: "charges", label: "Charges", number: "08" },
  { id: "thirdparty", label: "Third Party Services", number: "09" },
  { id: "referrer", label: "Referrer Terms", number: "10" },
  { id: "datasharing", label: "Carbon Emissions Data Sharing", number: "11" },
  { id: "donation", label: "Voluntary Donation Pool", number: "12" },
  { id: "relationship", label: "Relationship of the Parties", number: "13" },
  { id: "prohibitedpersons", label: "Prohibited Persons", number: "14" },
  { id: "currency", label: "Currency", number: "15" },
  { id: "expenses", label: "Expenses", number: "16" },
  { id: "delivery", label: "Delivery", number: "17" },
  { id: "privacy", label: "Privacy and Data", number: "18" },
  { id: "content", label: "Content Ownership", number: "19" },
  { id: "liability", label: "Limitation of Liability", number: "20" },
  { id: "modification", label: "Termination, Suspension or Modifications to the Services", number: "21" },
  { id: "governing", label: "Governing Law", number: "22" },
  { id: "disclaimer", label: "Disclaimer of Warranties", number: "23" },
  { id: "severability", label: "Severability", number: "24" },
  { id: "feedback", label: "Feedback", number: "25" },
  { id: "energy", label: "Energy Sharing", number: "26" },
  { id: "updates", label: "Update on Terms and Conditions", number: "27" },
];



  return (
    <div className="terms">
      <Header />
       <div
        className=" w-full h-[478px] flex items-center"
        style={{
          backgroundImage: `url(${termImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="ml-44 " />
        <div className=" relative  text-black">
          <h1 className="text-[64px] font-bold h-[76px] mt-32 mb-10 ">Terms & Conditions</h1>
          <p className="font-light leading-relaxed text-[24px] ">
            Take a moment to get familiar with the usage rules. Your <br></br> agreement to these rules comes into play as soon as you <br></br>start using the website. It's essential to know and follow <br></br>the terms laid out here.
          </p>
        </div>
      </div>
     


     {/* Main Content Layout */}
     
      <div className="flex py-12 px-4 gap-8 ml-20">
        {/* Sidebar Index */}
        <aside className="w-[370px] bg-[#FAFAFA] rounded-lg ml-20 p-6 h-[2062px] top-24">
  <h2 className="text-[32px] font-medium mb-4">INDEX</h2>
  <ul className="space-y-5  text-[24px] ">
    {sections.map((section, idx) => (
      <li key={section.id}>
        <a
          href={`#${section.id}`}
          className="flex justify-between items-center text-gray-700 hover:text-blue-600 transition"
        >
          {/* Force wrapping within the available width */}
          <span className="block text-2xl break-words whitespace-normal leading-tight w-auto space-x-0  ">
            {section.label}
          </span>
          <span className="text-lg text-gray-400 ml-10" >
            {String(idx + 1).padStart(2, "0")}
          </span>
        </a>
      </li>
    ))}
  </ul>
</aside>

        {/* <aside className="w-[318px] bg-[#FAFAFA] rounded-lg ml-20 p-6 h-[2062px] top-24 ">
          <h2 className="text-[32px] font-medium mb-4">INDEX</h2>
          <ul className="space-y-5 text-[24px] w-64">
            {sections.map((section, idx) => (
              <li key={section.id}>
                <a
                  href={`#${section.id}`}
                  className="flex justify-between items-center text-gray-700 hover:text-blue-600 transition"
                >
                  <span className=" text-justify break-before-avoid text-2xl">
  {section.label}
</span>


                  <span className="text-lg text-gray-400">{String(idx + 1).padStart(2, "0")}</span>
                </a>
              </li>
            ))}
          </ul>
        </aside> */}
        {/* Main Terms Content */}
        <main className="flex flex-col p-0 gap-6 w-[834px] relative bg-white rounded-lg">
          {/* Introduction */}
          <section id="introduction" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">1. Introduction</h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              These Terms and Conditions govern your use of the CloseCarbon platform, website, and related services (collectively referred to as the "Platform"). By accessing or using the Platform, you agree to comply with and be bound by these Terms. If you do not agree with these Terms, please do not use the Platform. If you choose not to accept this agreement, refrain from accessing the CloseCarbon platform. For any inquiries about this agreement, feel free to reach out to us via email at support@closecarbon.com.
            </p>
          </section>
          {/* Acceptance of Terms */}
          <section id="acceptance" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">2. Acceptance of Terms</h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              By accessing or using the Platform, you confirm that you have read, understood, and agreed to these Terms, including our Privacy Policy. These Terms constitute a legally binding agreement between you and CloseCarbon.
            </p>
          </section>
          {/* Legal Capacity */}
          <section id="legal" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">3. Legal Capacity</h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              You must be at least 18 years old or the legal age in your jurisdiction to use the Platform. If you are accessing the Platform on behalf of a company or organization, you represent and warrant that you have the authority to bind that entity to these Terms.
            </p>
          </section>
          {/* User of the Platform */}
          <section id="user" className="flex flex-col items-start gap-6 w-full mb-5 scroll-mt-24">
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">4. Use of the Platform</h3>
            <div className="flex flex-col items-start gap-4 w-full pl-2">
              <h4 className="font-medium text-[18px] leading-[21px] text-[#3B3B3B]">Registration</h4>
              <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
                To fully utilize the Platform's features, you may need to create an account. You agree to provide accurate and up-to-date information during the registration process.
              </p>
            </div>
          </section>
          {/* Security Measures */}
          <section id="security" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24 pl-2">
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">5. Security Measures</h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              Closecarbon maintains physical, technical, and administrative procedures to protect the data we collect and to secure it from improper or unauthorized use. We work hard to protect data in our custody and control from loss, misuse, and unauthorized access, use, disclosure, modification, or destruction, and to use industry-standard security measures in order to ensure an appropriate level of security in light of reasonably available methods in relation to the risks and nature of the information we collect.
            </p>
          </section>
          {/* Prohibited Activities */}
          <section id="prohibited" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24 pl-2">
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">6. Prohibited Activities</h3>
            <p className="text-[16px] leading-[24px] text-[#3B3B3B]">
    You agree not to:
  </p>
  <ul className="list-disc pl-6 text-[16px] leading-[24px] text-[#3B3B3B] space-y-2">
    <li>Use the Platform for any unlawful or harmful purposes.</li>
    <li>Impersonate any person or entity or misrepresent your affiliation with any entity.</li>
    <li>Attempt to gain unauthorized access to the Platform, its servers, or networks.</li>
    <li>Interfere with the proper functioning of the Platform.</li>
    <li>Engage in any activity that could harm the reputation or integrity of CloseCarbon.</li>
    <li>
      Use our Products or Services if you are not eligible or use them for purposes other
      than their intended use.
    </li>
    <li>
      Violate any applicable law, contract, intellectual property right, or commit a tort.
    </li>
    <li>Engage in harassing, threatening, intimidating, predatory, or stalking conduct.</li>
    <li>Use or attempt to use another user’s account or information without authorization.</li>
    <li>
      Impersonate or post on behalf of any person or entity or misrepresent your affiliation.
    </li>
    <li>Sell or resell our Products or Services.</li>
    <li>Copy, reproduce, distribute, publicly perform, or publicly display all or portions of our Products or Services.</li>
    <li>
      Modify our Products or Services, remove proprietary notices, or make derivative works.
    </li>
    <li>
      Use our Products or Services in a way that disrupts, damages, or inhibits others
      or impairs functionality.
    </li>
    <li>
      Reverse-engineer any aspect of our Products or Services or bypass access controls.
    </li>
    <li>
      Use data mining, robots, or similar tools to scrape or extract data from our Products or Platform.
    </li>
    <li>
      Develop or use apps or software that interact with our Products or Services without
      prior written consent.
    </li>
    <li>
      Link to our Products or Services in a way that damages our reputation or implies unauthorized
      association or endorsement.
    </li>
    <li>
      Use our Products or Services for any illegal or unauthorized purpose, or encourage or
      promote any activity that violates these Terms.
    </li>
  </ul>
  <p className="text-[16px] leading-[24px] text-[#3B3B3B] mt-4">
    Enforcement of this section is solely at the Company’s discretion, and failure to enforce
    it in some instances does not constitute a waiver of our right to enforce it in another instance.
  </p>
          </section>
          
          {/* Carbon Emission Tracking and Incentives */}
          <section id="carbon" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
              7. Carbon Emission Tracking and Incentives
            </h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              <span className="font-semibold">Accuracy of Data:</span> Users must provide accurate and truthful information about wallet address or plant address for carbon token to be generated during the KYC process.
            </p>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              <span className="font-semibold">Carbon Incentives:</span> CloseCarbon does not guarantee the conversion of carbon credits or any financial benefit. We provide tools to help track emissions and assist with the process, but the results may vary depending on external factors.
            </p>
            <p className="font-normal text-[16px] leading-[24px] text-[#141414]">
              Charges: 10% charges of every carbon credit approved shall be automatically deducted by CloseCarbon
            </p>
          </section>


{/* Charges and CCRT Details */}
<section
  id="charges"
  className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
>
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
   8.  Charges
  </h3>

  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The CloseCarbon Reduction Tonne (CCRT) is a reward system designed to support
    environmental sustainability initiatives by facilitating controlled tonne transfers.
    The primary recipient of this tonne is Netzence Sustainability, but other approved
    entities can also receive them.
  </p>

  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    CloseCarbon Reduction Tonne (CCRT) is issued by CloseCarbon after confirming that
    carbon emission reduction data meets specific standards. The CCRT does not entitle
    a user to a stake in the Company or the CloseCarbon Platform, neither does it serve
    as a security or equity of any sort—it is only an incentive given as reward for the
    reduction of Carbon Emissions.
  </p>

  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The CloseCarbon Platform reserves the exclusive right to update, change, amend and
    review these rates and charges with subsequent notice to the user. By agreeing to
    these Terms and Conditions, you agree and consent to these rates and charges and
    they become applicable to you.
  </p>

  <p className="font-normal text-[16px] leading-[24px] text-[#141414]">
    One CCRT represents approximately one tonne of carbon dioxide (CO₂) that has been
    emitted. For every CCRT earned by the User/Facility, the following rates and charges
    are applicable and so divided: <br />
    • User/Facility: 70% (The users) <br />
    • Netzence: 23% (Our company) <br />
    • CCV or Sub-CCV: 7% (Third-party bodies that verify the carbon emission data)
  </p>
</section>




{/* Third Party Services */}
<section
  id="thirdparty"
  className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
>
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
   9.  Third Party Services
  </h3>

  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    Our Product and Services which include calculating User’s carbon emissions
    reduction, issuing and exchanging CCRT, etc., rely on or interoperate with
    third-party products and services, which includes verifying calculated
    carbon emission, internet and mobile operators (collectively called
    “Third-Party Services”). Some third-party service providers whose services
    we require for the dispensing of our services are:
  </p>

  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    • <span className="font-semibold">CloseCarbon Verifiers (CCV):</span> An
    accredited verification body registered on CloseCarbon that verifies the
    reduction of carbon emissions of a User. <br />
    • <span className="font-semibold">Sub-CloseCarbon Verifiers (Sub-CCV):</span>{' '}
    A verifier registered under a CCV. <br />
    • <span className="font-semibold">Network Service Providers:</span> Provides
    stable internet services for real-time transmission of data to the Company.{' '}
    <br />
    • <span className="font-semibold">Payment Service Providers:</span> Provides
    electronic banking services between the Company and a User or Donor.
  </p>

  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    These Third-Party Services are not under our management and thus beyond our
    control, however their operation may impact the use and reliability of our
    Services and Products. You acknowledge and agree that: <br />
    • The use of our Product and Services are dependent on third-party service
    providers. <br />
    • These Third-Party Services may not operate reliably 100% of the time,
    which may impact the way our Products or Services operate. <br />
    • We have no obligation to monitor Third-Party Services, and we may block or
    disable your access to any Third-Party Services (in whole or part) through
    our Products or Services at any time. <br />
    • Your access to and use of such Third-Party Services may be subject to
    additional terms, conditions, and policies applicable to such Third-Party
    Service Providers (including terms of service or privacy policies of the
    providers of such Third-Party Service Providers). You are responsible for
    any consent you give to the Privacy Policies or the Terms and Conditions of
    these Third-Party Service Providers in the course of using our Product and
    Services.
  </p>
</section>



{/* Carbon Emissions Data Sharing */}
<section id="carbon-data-sharing" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
     Carbon Emissions Data Sharing
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The United Nations Framework Convention on Climate Change via The Paris Agreement requires Party States to prepare, 
    communicate and maintain successive Nationally Determined Contributions Value as a mechanism to manage and calculate 
    carbon emissions of party states and combat dangerous climate change. The Federal Republic of Nigeria is a party to 
    this Agreement, thus Netzence may be required to transmit calculated carbon emission data to the Federal Republic of 
    Nigeria or to the UNFCCC. By agreeing to these Terms and Conditions, you consent that your carbon emissions data may 
    be shared with these entities where the Company is under an obligation to do so.
  </p>
</section>

{/* Referrers Terms */}
<section id="referrer" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    10. Referrers Terms
  </h3>

  <h4 className="font-medium text-[18px] leading-[27px] text-[#3B3B3B]">
    Authorized Referrers
  </h4>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    This clause applies to individuals expressly authorized by Netzence in writing to carry out referral activities, thus making them “Authorized Referrers”. The relationship between Netzence and these Authorized Referrers does not create a master-servant relationship or an agency relationship. Netzence may revoke this authorization at any time and for any reason.
  </p>

  <h4 className="font-medium text-[18px] leading-[27px] text-[#3B3B3B]">
    Customer Agreement
  </h4>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    An Authorized Referrer is solely and exclusively responsible for the terms of agreement between himself and the Prospect and their overall business relationship.
  </p>
</section>

{/* Carbon Emissions Data Sharing */}
<section id="datasharing" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
  11.   Carbon Emissions Data Sharing
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The United Nations Framework Convention on Climate Change via The Paris Agreement requires Party States to prepare, 
    communicate and maintain successive Nationally Determined Contributions Value as a mechanism to manage and calculate 
    carbon emissions of party states and combat dangerous climate change. The Federal Republic of Nigeria is a party to 
    this Agreement, thus Netzence may be required to transmit calculated carbon emission data to the Federal Republic of 
    Nigeria or to the UNFCCC. By agreeing to these Terms and Conditions, you consent that your carbon emissions data may 
    be shared with these entities where the Company is under an obligation to do so.
  </p>
</section>

{/* 12. Voluntary Donation Pool */}
<section id="donation" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    12. Voluntary Donation Pool
  </h3>

  {/* Intention */}
  <h4 className="font-medium text-[18px] leading-[27px] text-[#3B3B3B]">
    Intention
  </h4>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
 The Donor agrees that there is a clear and voluntary intention on the part of the Donor to transfer ownership of the donated funds to the Company without any expectation to receive something or incentive in return for the donation made either in cash, kind or service. 
The Donor agrees that the donation made under this pool does not constitute a payment for a stake in the company as security, equity or debt of any sort.  
The Donor agrees that this donation is not made as a result of coercion, undue influence or fraud. 
The Donor agrees that his/her CONSENT is provided to CloseCarbon to publish the name of the Donor on and beyond the platform. 
  </p>
</section>

{/* 13. Relationship of the Parties */}
<section id="relationship" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    13. Relationship of the Parties
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The Parties agree that the relationship with respect to any donation contemplated herein is one of “Donee” and “Donor” 
    only and no provision of this agreement shall be construed to create any other type of status or relationship between 
    the Parties with respect to such donation.
  </p>
</section>

{/* 14. Prohibited Persons */}
<section id="prohibitedpersons" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    14. Prohibited Persons
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    INDIVIDUALS, GROUPS, ASSOCIATIONS AND COMPANIES LISTED ON&nbsp;THE UNITED NATIONS SANCTIONS LIST,&nbsp;
    THE NIGERIAN SANCTION LIST,&nbsp;AND&nbsp;THE SPECIALLY DESIGNATED NATIONALS AND BLOCKED PERSONS LIST&nbsp;
    ARE EXPRESSLY AND STRICTLY PROHIBITED FROM DONATING ON THIS PLATFORM.
  </p>
</section>


{/* 15. Currency */}
<section id="currency" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    15. Currency
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The acceptable currencies for Donation on this Platform are The Nigerian Naira (NGN), 
    The Ghanaian Cedis (GHC) and The United States Dollar (USD). For your convenience, 
    please note that we only accept donations via bank transfers or electronic transfers.
  </p>
</section>


{/* 16. Expenses */}
<section id="expenses" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    16. Expenses
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The Donor agrees to be responsible for all expenses incurred in connection with the donation, 
    including but not limited to bank transfer, bank charges, and any other applicable charges 
    accrued in the course of a donation.
  </p>
</section>



{/* 17. Delivery */}
<section id="delivery" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    17. Delivery
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The Donor agrees to deliver the donation via electronic bank transfers. Upon receipt and 
    confirmation of a donation, the Company will subsequently issue a downloadable Certificate 
    of Donation to the Donor on the Platform.
  </p>
</section>


{/* 18. Privacy and Data */}
<section id="privacy" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    18. Privacy and Data
  </h3>

  {/* Privacy */}
  <h4 className="font-medium text-[18px] leading-[27px] text-[#3B3B3B]">
    Privacy
  </h4>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    CloseCarbon respects your privacy and handles your personal data in accordance with our Privacy
    Policy and the Nigerian Data Protection Act 2023, the NDPR, and the GDPR.
  </p>

  {/* Data Ownership */}
  <h4 className="font-medium text-[18px] leading-[27px] text-[#3B3B3B]">
  Data Ownership 
  </h4>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    You retain ownership of the data you submit to the Platform. CloseCarbon may use aggregated,
    anonymized data for research and improvement purposes. You may read our <a className="underline text-green-700" href="/privacy-policy"> Privacy Policy here.</a> 
  </p>
</section>

          {/* Content Ownership */}
          <section
            id="ContentOwnership"
            className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
          >
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
              19. Content Ownership
            </h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              All content provided on the Platform, including text, graphics,
              logos, source codes, and software, is the property of Netzence
              Sustainability Ltd and protected by copyright laws. You may not
              use, reproduce, or distribute this content without prior written
              consent from the Company.
            </p>
          </section>





{/* 20. Limitation of Liability */}
<section id="content" className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24">
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    20. Limitation of Liability
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    In the absence of negligence, bad faith or wilful misconduct by the Company/CloseCarbon Platform,
    we shall not be liable to the user or to any other person, including any party claiming by,
    through or on behalf of an authorized User, for any losses, liabilities, damages, costs or
    expenses arising out of any error or mistaken data or other information provided to us by the
    User or any other person acting on behalf of the User. CloseCarbon shall not be liable for any
    direct, indirect, incidental, consequential, or punitive damages or loss arising out of your
    use or inability to use the Platform.
  </p>
</section>


{/* 21. Termination, Suspension or Modification to the Services */}
<section
  id="liability"
  className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
>
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    21. Termination, Suspension or Modification to the Services
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The Company reserves the exclusive right to modify our Services or to suspend or terminate the
    provision of all or part of our Products or Services to you at any time. We may provide you with
    notice in advance of the suspension or discontinuation of all or part of our Products or
    Services, such as by sending an email or providing a notice through our Products or Services.
    All modifications and additions to the Products and Services will be governed by the Terms,
    Updated or Supplemental Terms, unless otherwise expressly stated by The Company in writing. You
    also have the right to stop using our Products and Services at any time, especially where you do
    not agree with our updated or supplementary terms, and you may terminate your consent to these
    Terms by ceasing use of our Products and Services. We are not responsible for any loss or harm
    related to your inability to access or use our Services.
  </p>
</section>


{/* 22. Governing Law */}
<section
  id="modification"
  className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
>
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    22. Governing Law
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    In the absence of negligence, bad faith or wilful misconduct by the Company/CloseCarbon Platform,
    we shall not be liable to the user or to any other person, including any party claiming by,
    through or on behalf of an authorized User, for any losses, liabilities, damages, costs or
    expenses arising out of any error or mistaken data or other information provided to us by the
    User or any other person acting on behalf of the User. CloseCarbon shall not be liable for any
    direct, indirect, incidental, consequential, or punitive damages or loss arising out of your use
    or inability to use the Platform.
  </p>
</section>


{/* 23. Disclaimer of Warranties */}
<section
  id="governing"
  className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
>
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    23. Disclaimer of Warranties
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    The Platform is provided &quot;as is,&quot; without warranties of any kind, to any user registered under
    the platform, whether express or implied. CloseCarbon makes no representations or warranties
    regarding the accuracy or completeness of the information on the Platform.
  </p>
</section>



{/* 24. Severability */}
<section
  id="severability"
  className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
>
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    24. Severability
  </h3>
  <p className="font-normal text-[16px] leading-[23px] text-[#3B3B3B]">
    Where any part of these Terms is found to be unenforceable or unlawful by reason of an existing law,
    rules or regulation, or where it is held by a Nigerian court of Law to be unconscionable, then:  
    <br />• The unenforceable or unlawful provision alone will be severed from these Terms.  
    <br />• The severance of the unenforceable or unlawful provision will have no impact whatsoever on
    the remainder of these Terms.  
    <br />• The unenforceable or unlawful provision may be revised to the extent required to render the
    Terms enforceable.
  </p>
</section>


{/* 25. Feedback */}
<section
  id="feedback"
  className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
>
  <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
    25. Feedback
  </h3>
  <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
    You acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other
    information regarding the Platform or the Services provided by you to us are non-confidential
    and shall become our sole property. We shall own exclusive rights, including all intellectual
    property rights, and shall be entitled to the unrestricted use and dissemination of Feedback
    for any lawful purpose, commercial purpose or otherwise, without acknowledgment or
    compensation to you. You hereby waive all moral rights to any such Feedback, and you warrant
    that any such Feedback is original to you or that you have the right to submit such Feedback.
    You agree that there shall be no recourse against us for any alleged or actual infringement or
    misappropriation of any proprietary right(s) in your Feedback.
  </p>
</section>



          {/* Energy Sharing */}
          <section
            id="energy"
            className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
          >
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
              26. Energy Sharing
            </h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              Users shall have the right to share their surplus energy with
              other third-party users on the CloseCarbon platform for profit.
              The transactions between users shall be logged and recorded on the
              platform to ensure transparency and accuracy in accounting.
            </p>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              Energy sharing shall be governed by the Platform’s terms and
              verification procedures to ensure accuracy, traceability, and fair
              allocation. By participating in the energy sharing system on the
              platform, users consent to the automated logging, measurement, and
              billing of energy units shared, received, or consumed.
            </p>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              Users may select any available payment options on the platform for
              energy sharing transactions:
            </p>
            <ul className="list-disc list-inside font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              <li>
                For payments through personal bank transfers or
                unautomated/semi-automated financial methods, users may agree to
                settle payments between themselves. In this case, the platform
                will only record the energy transaction and the agreed unit
                price but will not facilitate the payment.
              </li>
              <li>
                Users may also choose to use the payment gateway provided on the
                platform. Payments for energy transactions shall be automatically
                deducted and credited through the platform.
              </li>
            </ul>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              The platform shall generate electronic invoices and receipts upon
              each transaction. Failure to make payment within 24 hours of the
              commencement of the transaction for P2P transfers shall constitute
              a breach of the agreement and will automatically render the
              transaction cancelled.
            </p>
          </section>

          {/* Updates on Terms and Conditions */}
          <section
            id="updates"
            className="flex flex-col items-start gap-4 w-full mb-5 scroll-mt-24"
          >
            <h3 className="font-medium text-[24px] leading-[29px] text-[#141414]">
              27. Updates on Terms and Conditions
            </h3>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              We reserve the sole and exclusive right to change or modify all or
              portions of these Terms of Service at any time. Where possible, we
              will provide notice of any changes to these Terms of Service.
              Changes may be made on short or no notice when such change is
              required by law.
            </p>
            <p className="font-normal text-[16px] leading-[24px] text-[#3B3B3B]">
              When we make changes to these Terms, we will post the revised
              Terms on this platform. Your continued use of our service or
              platform after the date of any changes constitutes your acceptance
              of the new or updated Terms of Service. If you do not wish to
              accept the new Terms of Service, you must discontinue the use of
              the platform.
            </p>
          </section>















        </main>
      </div>

      <Footer />
    </div>
  );
}
